<template>
  <div>
    <info-text i18n="integrations.helper.communication-gateways.create" />
    <va-create-layout>
      <communication-gateways-form :item="item" />
    </va-create-layout>
  </div>
</template>

<script>
import InfoText from "@/components/helper/InfoText";
export default {
  components: { InfoText },
  props: ["resource", "title", "item"]
};
</script>
